module.exports = __webpack_public_path__ + "static/media/SupportIcon.497f557f.svg";